(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bs-bewertungen"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bs-reviews')) {
    customElements.define(
      'bs-reviews',
      class extends HTMLElement {
        connectedCallback() {
          this.cards = [...this.querySelectorAll('.bs-rv__card')];
          this.cards.forEach((card) => {
            const btn = card.querySelector('.bs-rv__more');
            if (!btn) return;
            btn.addEventListener('click', () => {
              const open = card.classList.toggle('is-open');
              btn.setAttribute('aria-expanded', open);
              btn.textContent = open ? 'Weniger anzeigen' : 'Weiterlesen';
            });
          });
          this.measure = this.measure.bind(this);
          this.measure();
          if (window.ResizeObserver) {
            this.ro = new ResizeObserver(this.measure);
            this.ro.observe(this);
          }
        }
        disconnectedCallback() {
          if (this.ro) this.ro.disconnect();
        }
        measure() {
          this.cards.forEach((card) => {
            if (card.classList.contains('is-open')) return;
            const text = card.querySelector('.bs-rv__text');
            const btn = card.querySelector('.bs-rv__more');
            if (text && btn) btn.hidden = text.scrollHeight <= text.clientHeight + 2;
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
